export default "__VITE_ASSET__031ef081__"